import * as Assert from "./Assert";

/**
 * Returns whether or not the object exists. Check if it is not undefined and not null.
 * @param {*} obj 
 */
export function exists(obj)
{
    return typeof(obj) !== "undefined" && obj !== null;
}

/**
 * Safely get the value of a property on a nested objects. If the get fails, then null is returned.
 * i.e. let position = get([config, "transform", "position"]);
 * @param {*[]} path 
 */
export function get(path)
{
    let i = null;
    let j = null;
    i = path.shift();
    while (path.length > 0)
    {
        j = path.shift();
        if (!exists(i) || !exists(j) || !exists(i[j]))
        {
            return null;
        }
        i = i[j];
    }
    return i;
}

/**
 * Safely get the value of a property on a nested objects. If the get fails, then the fallback is returned.
 * i.e. let x = getElse([config, "transform", "position", "x"], 0);
 * @param {*[]]} path 
 * @param {*} fallback 
 */
export function getElse(path, fallback)
{
    let val = get(path);
    return val !== null ? val : fallback;
}

/**
 * Safely get the value of a property on a nested objects. If the get fails, then an error is thrown
 * i.e. let position = getAssert([config, "transform", "position"], "Error: Position not found in config");
 * @param {*[]} path 
 * @param {*} msg 
 */
export function getAssert(path, msg)
{
    let val = get(path);
    Assert.isTrue(exists(val), msg);
    return val;
}